import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tabTitle"];
  static values = {
    tabKey: { type: String, default: "lastSelectedTabId" },
    mobileBreakpoint: { type: Number, default: 768 },
    defaultTabName: { type: String, default: "RESULTS OVERVIEW" }
  };

  connect() {
    this.currentLayout = this.getLayout();
    this.trackTabClicks();
    this.activateLastTab();
    this.updateDropdownTabTitleFromInitial();

    window.addEventListener("resize", this.debounce(() => {
      const newLayout = this.getLayout();
      if (newLayout !== this.currentLayout) {
        this.currentLayout = newLayout;
        this.activateLastTab();
      }
    }, 300));
  }

  getLayout() {
    return window.innerWidth < this.mobileBreakpointValue ? "mobile" : "desktop";
  }

  getTabSelector(baseId) {
    const suffix = this.getLayout() === "mobile" ? "_mobile" : "";
    return `a[href="#${baseId}${suffix}"]`;
  }

  activateLastTab() {
    const baseId = sessionStorage.getItem(this.tabKeyValue);
    if (!baseId) return;

    const selector = this.getTabSelector(baseId);
    const tabTrigger = document.querySelector(selector);
    if (tabTrigger) {
      new bootstrap.Tab(tabTrigger).show();
      this.updateDropdownTabTitle(baseId);
    }
  }

  trackTabClicks() {
    document.querySelectorAll('a[data-toggle="tab"]').forEach((link) => {
      link.addEventListener("click", (e) => {
        const href = e.currentTarget.getAttribute("href");
        const baseId = href.replace("#", "").replace("_mobile", "");
        sessionStorage.setItem(this.tabKeyValue, baseId);
        this.updateDropdownTabTitle(baseId);
      });
    });
  }

  updateDropdownTabTitle(baseId) {
    const tabItem = document.querySelector(
      `#reportTabs .dropdown-item-aq[href="#${baseId}_mobile"], #reportTabs .dropdown-item-aq[href="#${baseId}"]`
    );
    const tabName = tabItem?.dataset.tabName || this.defaultTabNameValue;
    if (this.hasTabTitleTarget) this.tabTitleTarget.textContent = tabName;
  }

  updateDropdownTabTitleFromInitial() {
    const defaultLink = document.querySelector(
      "#reportTabs .dropdown-item-aq[aria-selected='true']"
    );
    const baseId = defaultLink?.getAttribute("href")?.replace("#", "").replace("_mobile", "");
    if (baseId) this.updateDropdownTabTitle(baseId);
  }

  debounce(func, wait = 200) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
}
